// extracted by mini-css-extract-plugin
module.exports = {"content":"SaveAsDraft_content__3VszL","wrapper":"SaveAsDraft_wrapper__3XyWR","message":"SaveAsDraft_message__27qlu","actionBtns":"SaveAsDraft_actionBtns__HuI-X"};